import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Route } from 'react-router-dom';

import { Assignment, Book, Dragzone, Logo, Menu, Sidebar } from 'components';

import { getProfile, isAuthenticated } from 'redux/selectors/user';

import styles from './styles.scss';

@connect(state => ({
  authenticated: isAuthenticated(state),
  profile: getProfile(state),
}))
export default class Maker extends React.PureComponent {
  static contextTypes = {
    bookId: PropTypes.number,
    orderId: PropTypes.string,
  };

  componentWillMount() {
    this.showMessageOnExit();
  }

  componentDidUpdate() {
    this.showMessageOnExit();
    this.updateChat();
  }

  get user() {
    const { authenticated, profile } = this.props;

    return authenticated && profile
      ? {
          name: profile.get('first_name'),
          email: profile.get('email'),
          user_id: profile.get('id', ''),
          user_hash: profile.get('hash', ''),
        }
      : null;
  }

  updateChat = () => {
    const { authenticated } = this.props;

    try {
      const user = this.user;
      if (authenticated && window.Chatra && user) {
        window.Chatra('setIntegrationData', user);
      }
    } catch (e) {
      console.log(e);
    }
  };

  showMessageOnExit = () => {
    window.onbeforeunload = null;
    if (!process.env.DEBUG && !this.props.authenticated) {
      window.onbeforeunload = () => true;
    }
  };

  render() {
    const { orderId } = this.context;

    return (
      <Dragzone disabled={false}>
        <div className={styles.maker}>
          <Menu orderId={orderId} />
          <Sidebar orderId={orderId} />
          <div className={styles.content}>
            {orderId ? (
              <Book />
            ) : (
              <div className={styles.noSelection}>
                <Logo width={225} payoff={true} />
              </div>
            )}
          </div>
          <Route path="/:bookId/:orderId/assignment/:filter?" component={Assignment} />
          <div className={styles.noMobile}>
            {kroostApp.strings.smallScreensMessage1} <br />
            {kroostApp.strings.smallScreensMessage2}
          </div>
        </div>
      </Dragzone>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/maker/index.js